<template>
  <div class="configurator_map">
    <div class="configurator_wrapper">
      <div class="configurator_size" @click="switchPodSize()">
        <div class="size_button large"  :class="{'focused':podSize=='L'}">
          <svg xmlns="http://www.w3.org/2000/svg" width="7.376" height="11.44" viewBox="0 0 7.376 11.44">
            <path id="Tracé_101" data-name="Tracé 101" d="M1.2,0H8.576V-1.312H2.72V-11.44H1.2Z" transform="translate(-1.2 11.44)"/>
          </svg>
        </div>
        <div class="size_button small" :class="{'focused':podSize=='S'}">
          <svg xmlns="http://www.w3.org/2000/svg" width="9.152" height="11.888" viewBox="0 0 9.152 11.888">
            <path  d="M9.392-8.144c-.08-2.3-1.76-3.52-4.288-3.52-2.224,0-4.064,1.216-4.064,3.2A2.75,2.75,0,0,0,3.088-5.888c1.12.432,3.136.848,3.984,1.216C7.9-4.32,8.3-3.856,8.3-3.088c0,1.36-1.28,2.032-2.864,2.032-1.3,0-3.216-.528-3.36-2.72L.656-3.712C.7-1.216,2.592.224,5.456.224c2.32,0,4.352-1.28,4.352-3.392A2.866,2.866,0,0,0,7.68-6.032c-.832-.32-2.944-.784-3.968-1.184-.576-.224-1.168-.608-1.168-1.312,0-1.232,1.072-1.92,2.576-1.92,1.632,0,2.7.816,2.8,2.352Z" transform="translate(-0.656 11.664)" />
          </svg>
        </div>
      <svg  class="background" :class="{'small':podSize=='S','large':podSize=='L'}" xmlns="http://www.w3.org/2000/svg" width="48" height="40" viewBox="0 0 48 40">
        <rect  width="48" height="40" rx="20"/>
      </svg>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ConfiguratorMap',
  data(){
    return {

    }
  },
  props: ['bus'],
  computed:{
    ...mapGetters(['podSize','infoOpened'])
  },
  mounted(){

  },
  methods:{
    switchPodSize(){
      if(this.podSize == 'S') this.changePodSize('L')
      else this.changePodSize('S')
    },
    changePodSize(size){
      if(this.infoOpened){
        this.$store.dispatch('setInfoOpened',false);
      }
      this.$store.dispatch('setPodSize',size);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" >
.dark-mode{
  .configurator_size{
    background: rgb(26,25,27) !important;
    box-shadow: 0px 3px 4px rgba(201, 201, 201, 0) !important;
    border: 1px solid rgba(255, 255, 255, 0.16) !important;
    span{
      color:white;
    }
  }
}
.rectView{
  fill:#FFFFFF;
  stroke:rgba(201, 201, 201, 0.9);
  stroke-miterlimit:10;
}
.mainRect{
  width: 80;
}
.configurator_map{
  position: absolute;
  z-index: 9000;
  bottom: 50px;
  left: 123px;
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
  .configurator_wrapper{
    position: relative;
    width: 100%;
    height: 100%;

    .configurator_size{
      width: 84px;
      height: 40px;
      border-radius: 20px;
      background: transparent;
      border: 1px solid #3e3e3e;
      position: relative;
      left: 0;
      bottom: 0;
      text-align: center;
      .background{
        position: absolute;
        transform: translate(-1px,-1px);
        -webkit-transition: all .5s cubic-bezier(0, 0, 0.2, 1);
        -moz-transition: all .5s cubic-bezier(0, 0, 0.2, 1);
        -ms-transition: all .5s cubic-bezier(0, 0, 0.2, 1);
        -o-transition:all .5s cubic-bezier(0, 0, 0.2, 1);
        transition: all .5s cubic-bezier(0, 0, 0.2, 1);
        left: 0;
        rect{
          fill:#3e3e3e;
        }
        &.small{
          left: 35px;
        }
        &.large{
          left: 0;
        }
      }
      .size_button{
        -webkit-transition: all .5s cubic-bezier(0, 0, 0.2, 1);
        -moz-transition: all .5s cubic-bezier(0, 0, 0.2, 1);
        -ms-transition: all .5s cubic-bezier(0, 0, 0.2, 1);
        -o-transition:all .5s cubic-bezier(0, 0, 0.2, 1);
        transition: all .5s cubic-bezier(0, 0, 0.2, 1);
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        position: absolute;
        opacity: 1;
        cursor: pointer;
        height: 100%;
        display: flex;
        align-items: center;
        z-index: 1;
        fill:#3e3e3e;
        &.focused{
          svg{
            path{
              fill: white !important;
            }
          }
        }
      }
      .small{
        right: 2px;
      }
      .large{
        left:2px;
      }
    }
  }
}
</style>
